import { LEAFLINK_STATUSES_REFLECTING_ACTION } from './leaflink-statuses-reflecting-action.js';
export function leafLinkStatusReflectsAction(leafLinkStatus, action) {
    const reflecting = LEAFLINK_STATUSES_REFLECTING_ACTION[action];
    return leafLinkStatus != null && reflecting.includes(leafLinkStatus);
}
//# sourceMappingURL=leaflink-status-reflects-action.js.map